/* assets/j_cart-exclusive-gift.js
   NJC cart exclusive gift.
   Requires assets/j_cart-core.js.
*/

(function () {
  if (window.__j_cart_exclusive_gift_active) return;
  window.__j_cart_exclusive_gift_active = true;

  var refreshTimer = null;
  var isSyncing = false;
  var lastWriteAt = 0;
  var writeCooldown = 900;

  function getWrap() {
    return document.querySelector('[data-j-cart-exclusive]');
  }

  function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  function parseRules(wrap) {
    try {
      return JSON.parse(wrap.getAttribute('data-rules') || '[]');
    } catch (e) {
      return [];
    }
  }

  function getData() {
    var wrap = getWrap();

    if (!wrap) return null;

    return {
      wrap: wrap,
      cards: wrap.querySelector('[data-j-cart-exclusive-cards]'),
      customerLogged: isTrue(wrap.getAttribute('data-customer-logged')),
      rules: parseRules(wrap)
    };
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function uniqueCodes(codes) {
    var out = [];

    (codes || []).forEach(function (code) {
      code = normalizeCode(code);

      if (code && out.indexOf(code) === -1) {
        out.push(code);
      }
    });

    return out;
  }

  function getCodesFromUrl() {
    var codes = [];
    var params = new URLSearchParams(window.location.search);
    var pathMatch = window.location.pathname.match(/\/discount\/([^/?#]+)/i);

    [
      params.get('j_exclusive_code'),
      params.get('exclusive_code'),
      params.get('discount_code'),
      params.get('discount')
    ].forEach(function (code) {
      if (code) codes.push(code);
    });

    if (pathMatch && pathMatch[1]) {
      codes.push(pathMatch[1]);
    }

    return uniqueCodes(codes);
  }

  function getStoredCodes() {
    var rawSession = '';
    var rawLocal = '';
    var raw = '';

    try {
      rawSession = sessionStorage.getItem('njc_exclusive_codes') || '';
    } catch (e) {}

    try {
      rawLocal = localStorage.getItem('njc_exclusive_codes') || '';
    } catch (e2) {}

    raw = [rawSession, rawLocal].filter(Boolean).join(',');

    if (!raw) return [];

    return uniqueCodes(raw.split(','));
  }

  function saveCodes(codes) {
    var merged = getStoredCodes();

    uniqueCodes(codes).forEach(function (code) {
      if (merged.indexOf(code) === -1) {
        merged.push(code);
      }
    });

    try {
      sessionStorage.setItem('njc_exclusive_codes', merged.join(','));
    } catch (e) {}

    try {
      localStorage.setItem('njc_exclusive_codes', merged.join(','));
    } catch (e2) {}
  }

  function getActiveCodes() {
    var urlCodes = getCodesFromUrl();
    var storedCodes;

    if (urlCodes.length) {
      saveCodes(urlCodes);
    }

    storedCodes = getStoredCodes();

    return uniqueCodes(storedCodes.concat(urlCodes));
  }

  function cartHasDiscountCode(cart, code) {
    var apps;
    var i;

    code = normalizeCode(code);

    if (!code || !cart) return false;

    apps = []
      .concat(cart.cart_level_discount_applications || [])
      .concat(cart.discount_applications || []);

    for (i = 0; i < apps.length; i++) {
      if (normalizeCode(apps[i].title) === code) return true;
      if (normalizeCode(apps[i].code) === code) return true;
    }

    return false;
  }

  function accessAllowed(rule, customerLogged, cart) {
    var access = String(rule.access || 'exclusive_code');
    var code = normalizeCode(rule.code);
    var activeCodes = getActiveCodes();

    if (access === 'everyone') return true;
    if (access === 'guest') return !customerLogged;
    if (access === 'logged') return !!customerLogged;

    if (access === 'exclusive_code') {
      if (code && activeCodes.indexOf(code) !== -1) return true;
      if (rule.customer_tag_match === true) return true;
      if (rule.customer_metafield_match === true) return true;
      if (code && cartHasDiscountCode(cart, code)) return true;

      return false;
    }

    return false;
  }

  function isPromoLine(item) {
    var props = item && item.properties ? item.properties : {};

    return (
      isTrue(props._j_reward) ||
      isTrue(props._reward1) ||
      isTrue(props._reward2) ||
      isTrue(props._reward3) ||
      isTrue(props._j_auto_gift) ||
      isTrue(props._j_exclusive_gift) ||
      isTrue(props._jcg_gift)
    );
  }

  function getSpendSubtotal(cart) {
    var sum = 0;

    (cart.items || []).forEach(function (item) {
      if (isPromoLine(item)) return;
      sum += Number(item.line_price || 0);
    });

    return sum;
  }

  function getFirstAvailableVariant(product) {
    var variants = product && product.variants ? product.variants : [];

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available === true) return variants[i];
    }

    return null;
  }

  function selectGift(rule) {
    var products = rule.products || [];

    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      var variant;

      if (!product) continue;

      variant = getFirstAvailableVariant(product);
      if (!variant) continue;

      return {
        product: product,
        variant: variant
      };
    }

    return null;
  }

  function getGiftLine(cart, rule) {
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};

      if (isTrue(props._j_exclusive_gift) && String(props._j_exclusive_rule) === String(rule.id)) {
        return items[i];
      }
    }

    return null;
  }

  function cartHasTriggerProduct(cart, rule) {
    var triggerId = String(rule.trigger_product_id || '');
    var triggerHandle = String(rule.trigger_product_handle || '');

    if (!triggerId && !triggerHandle) return false;

    return (cart.items || []).some(function (item) {
        if (isPromoLine(item)) return false;

        return (
        String(item.product_id || '') === triggerId ||
        String(item.handle || '') === triggerHandle
        );
    });
  }

  function shouldRuleApply(rule, cart, total, customerLogged) {
    var triggerType;

    if (!rule || rule.enabled !== true) return false;
    if (!accessAllowed(rule, customerLogged, cart)) return false;

    triggerType = String(rule.trigger_type || 'threshold');

    if (triggerType === 'product') {
        return cartHasTriggerProduct(cart, rule);
    }

    return total >= Number(rule.threshold || 0);
  }

  function getInvalidGiftKeys(cart, rules, total, customerLogged) {
    var keys = [];

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var rule = null;

      if (!isTrue(props._j_exclusive_gift)) return;

      rules.forEach(function (r) {
        if (rule) return;

        if (String(props._j_exclusive_rule) === String(r.id)) {
          rule = r;
        }
      });

      if (!rule || !shouldRuleApply(rule, cart, total, customerLogged)) {
        if (item.key) keys.push(item.key);
      }
    });

    return keys;
  }

  function removeInvalidGifts(cart, rules, total, customerLogged) {
    var keys;
    var chain = Promise.resolve();

    if (!window.JCartCore) return Promise.resolve(false);

    keys = getInvalidGiftKeys(cart, rules, total, customerLogged);

    if (!keys.length) return Promise.resolve(false);

    keys.forEach(function (key) {
      chain = chain.then(function () {
        lastWriteAt = Date.now();

        return window.JCartCore.changeItem({
          id: key,
          quantity: 0
        });
      });
    });

    return chain.then(function () {
      return true;
    });
  }

  function showToast(text) {
    var toast = document.getElementById('j_cart-exclusive-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'j_cart-exclusive-toast';
      toast.className = 'j_cart-exclusive-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<div class="j_cart-exclusive-toast__box"></div>';
      document.body.appendChild(toast);
    }

    toast.querySelector('.j_cart-exclusive-toast__box').textContent = text || 'Your exclusive gift has been added to cart.';
    toast.classList.add('is-active');

    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(function () {
      toast.classList.remove('is-active');
    }, 2600);
  }

  function renderCards(data, cart, total) {
    var html = '';

    if (!data.cards) return;

    data.rules.forEach(function (rule) {
        if (!shouldRuleApply(rule, cart, total, data.customerLogged)) return;
        if (rule.show_message !== true) return;

        html += ''
        + '<div class="j_cart-exclusive__card">'
        +   '<p class="j_cart-exclusive__eyebrow">' + escapeHtml(rule.eyebrow || 'Exclusive Offer') + '</p>'
        +   '<p class="j_cart-exclusive__title">' + escapeHtml(rule.title || 'Your exclusive gift is waiting') + '</p>'
        +   '<p class="j_cart-exclusive__text">' + escapeHtml(rule.text || '') + '</p>'
        + '</div>';
    });

    data.cards.innerHTML = html;
    }

  function addGift(rule, selected) {
    if (!window.JCartCore || !selected || !selected.variant) return Promise.resolve(false);

    lastWriteAt = Date.now();

    return window.JCartCore.addItem({
      id: selected.variant.id,
      quantity: 1,
      properties: {
        _j_exclusive_gift: '1',
        _j_exclusive_rule: String(rule.id),
        _j_exclusive_variant: String(selected.variant.id),
        _j_exclusive_label: rule.cart_label || 'Exclusive Gift',
        _source: 'minicart'
      }
    }).then(function () {
      showToast(rule.toast_text);
      return true;
    });
  }

  function sync(cart) {
    var data = getData();
    var total;
    var chain;
    var now = Date.now();

    if (!data || !data.rules.length) return Promise.resolve(false);

    total = getSpendSubtotal(cart);

    renderCards(data, cart, total);

    if (now - lastWriteAt < writeCooldown) {
      return Promise.resolve(false);
    }

    return removeInvalidGifts(cart, data.rules, total, data.customerLogged).then(function (removed) {
      if (removed) {
        queueRefresh(700);
        return true;
      }

      chain = Promise.resolve(false);

      data.rules.forEach(function (rule) {
        chain = chain.then(function (changed) {
          var selected;

          if (changed) return true;
          if (!shouldRuleApply(rule, cart, total, data.customerLogged)) return false;
          if (getGiftLine(cart, rule)) return false;

          selected = selectGift(rule);
          if (!selected) return false;

          return addGift(rule, selected);
        });
      });

      return chain;
    });
  }

  function refresh() {
    if (isSyncing) return;
    if (!window.JCartCore) return;

    isSyncing = true;

    window.JCartCore.getCart()
      .then(sync)
      .catch(function () {})
      .finally(function () {
        isSyncing = false;
      });
  }

  function queueRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);

    refreshTimer = setTimeout(function () {
      refresh();
    }, typeof delay === 'number' ? delay : 200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    queueRefresh(120);
  });

  document.addEventListener('cart:refresh', function () {
    queueRefresh(450);
  });

  document.addEventListener('j:cart:mutated', function () {
    queueRefresh(650);
  });

  window.JCartExclusiveGift = {
    refresh: refresh,
    queueRefresh: queueRefresh,
    getActiveCodes: getActiveCodes
  };
})();